
(function () {
  'use strict';

  document.documentElement.classList.add('reveal-ready');

  (function () {
    var bar = document.querySelector('[data-utility-rotator]');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.um');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 5200);
  })();

  window.GW_TIERS = [{ q: 1, pct: 5 }, { q: 2, pct: 8 }, { q: 3, pct: 10 }, { q: 4, pct: 12 }];
  window.gwRenderBand = function (itemCount) {
    var band = document.querySelector('[data-gw-band]');
    if (!band) return;
    var tiers = window.GW_TIERS, cur = tiers[0], next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (itemCount >= tiers[i].q) cur = tiers[i];
      else { next = tiers[i]; break; }
    }
    var earned = band.querySelector('[data-gw-earned]');
    var fill = band.querySelector('[data-gw-fill]');
    var msg = band.querySelector('[data-gw-next]');
    if (earned) earned.textContent = cur.pct + '% off applied';
    if (fill) fill.style.width = (next ? Math.min(100, Math.round(itemCount / next.q * 100)) : 100) + '%';
    if (msg) {
      msg.innerHTML = next
        ? 'Add <b>1 more canvas</b> and your saving goes to <b>' + next.pct + '%</b>.'
        : 'Best saving unlocked \u2014 <b>12% off</b> this order.';
    }
  };

  function revealWhatIsVisible() {
    document.querySelectorAll('[data-reveal]:not(.revealed)').forEach(function (el) {
      if (el.getBoundingClientRect().top < (window.innerHeight || 0)) el.classList.add('revealed');
    });
  }
  window.addEventListener('load', revealWhatIsVisible);
  setTimeout(revealWhatIsVisible, 3000);

  const header = document.querySelector('.site-header');
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (window.scrollY > 80) header.classList.add('condensed');
          else header.classList.remove('condensed');
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach((el) => io.observe(el));

    revealEls.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 0)) {
        el.classList.add('revealed');
        io.unobserve(el);
      }
    });

    setTimeout(() => {
      revealEls.forEach((el) => el.classList.add('revealed'));
    }, 2000);
  } else {
    revealEls.forEach((el) => el.classList.add('revealed'));
  }

  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-overlay');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  openers.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  closers.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); closeCart(); }));
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  /* Cart quantities (drawer + cart page): the server is the source of truth. A step button or a typed quantity
     posts /cart/change.js for that line, then the page reloads so totals, discounts and the bag count are Shopify's. */
  function setLine(key, qty) {
    if (!key) return;
    document.documentElement.classList.add('wa-cart-busy');
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(() => { location.reload(); })
      .catch(() => { document.documentElement.classList.remove('wa-cart-busy'); });
  }
  document.querySelectorAll('[data-cart-item]').forEach((item) => {
    const key = item.getAttribute('data-line-key');
    const input = item.querySelector('input.qty');
    const cur = () => parseInt(input && input.value, 10) || 0;
    item.querySelector('.qty-plus')?.addEventListener('click', (e) => { e.preventDefault(); setLine(key, cur() + 1); });
    item.querySelector('.qty-minus')?.addEventListener('click', (e) => { e.preventDefault(); setLine(key, cur() - 1); });
    input?.addEventListener('change', () => setLine(key, cur()));
    item.querySelector('.remove')?.addEventListener('click', (e) => { e.preventDefault(); setLine(key, 0); });
  });

  const swatches = document.querySelectorAll('.swatch');
  const galleryHero = document.querySelector('[data-gallery-hero]');
  swatches.forEach((sw) => {
    sw.addEventListener('click', () => {
      swatches.forEach((s) => s.classList.remove('active'));
      sw.classList.add('active');
      const img = sw.dataset.image;
      if (img && galleryHero) galleryHero.src = img;
    });
  });

  const thumbs = document.querySelectorAll('.gallery-thumbs img');
  thumbs.forEach((t) => {
    t.addEventListener('click', () => {
      thumbs.forEach((x) => x.classList.remove('active'));
      t.classList.add('active');
      if (galleryHero) galleryHero.src = t.dataset.full || t.src;
    });
  });

  const sizeRadios = document.querySelectorAll('input[name="panel-size"]');
  const priceOut = document.querySelector('[data-pdp-price]');
  sizeRadios.forEach((r) => {
    r.addEventListener('change', () => {
      if (priceOut && r.dataset.price) priceOut.textContent = '₹' + Number(r.dataset.price).toLocaleString('en-IN');
    });
  });

  const stickyBar = document.querySelector('.sticky-bar');
  const stickyTrigger = document.querySelector('[data-sticky-trigger]');
  if (stickyBar && stickyTrigger) {
    /* the bar shows once the main Add to cart has scrolled above the viewport (a scroll check, so a jump also counts) */
    let tick = false;
    const upd = () => { tick = false; stickyBar.classList.toggle('visible', stickyTrigger.getBoundingClientRect().bottom < 0); };
    const req = () => { if (!tick) { tick = true; requestAnimationFrame(upd); } };
    window.addEventListener('scroll', req, { passive: true }); window.addEventListener('resize', req); upd();
  }

  const calcW = document.querySelector('[data-calc-w]');
  const calcH = document.querySelector('[data-calc-h]');
  const calcOut = document.querySelector('[data-calc-out]');
  const calcSubtotal = document.querySelector('[data-calc-subtotal]');
  function runCalc() {
    if (!calcW || !calcH || !calcOut) return;
    const w = parseFloat(calcW.value) || 0;
    const h = parseFloat(calcH.value) || 0;
    if (!w || !h) { calcOut.textContent = '—'; if (calcSubtotal) calcSubtotal.textContent = '—'; return; }
    const panelW = 92;
    const panels = Math.ceil((w * 100 * 1.05) / panelW);
    calcOut.textContent = panels + ' panels · ' + (panels * 3).toFixed(1) + 'm total run';
    if (calcSubtotal) calcSubtotal.textContent = '';  // mural sq-ft maths removed; the calculator is now a static spec block
  }
  if (calcW && calcH) {
    calcW.addEventListener('input', runCalc);
    calcH.addEventListener('input', runCalc);
  }

  const chapterContinue = document.querySelectorAll('[data-chapter-next]');
  chapterContinue.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const target = btn.dataset.chapterNext;
      const currentBlock = btn.closest('.chapter-block');
      const nextBlock = document.querySelector('#' + target);
      if (!nextBlock) return;
      if (currentBlock) currentBlock.style.opacity = '0.4';
      setTimeout(() => {
        nextBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const progress = document.querySelector('[data-intake-progress]');
        if (progress && btn.dataset.progressLabel) progress.textContent = btn.dataset.progressLabel;
      }, 240);
    });
  });

  const cookie = document.querySelector('.cookie-strip');
  if (cookie) {
    try { if (localStorage.getItem('wa-cookie-consent')) cookie.classList.add('hidden'); } catch (e) {}
    document.querySelectorAll('[data-cookie-dismiss]').forEach((b) => {
      b.addEventListener('click', () => {
        cookie.classList.add('hidden');
        try { localStorage.setItem('wa-cookie-consent', '1'); } catch (e) {}
      });
    });
  }

  document.querySelectorAll('.filter-group ul').forEach((ul) => {
    ul.addEventListener('click', (e) => {
      if (e.target.tagName === 'LI') {
        ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
        e.target.classList.add('active');
      }
    });
  });
  document.querySelectorAll('.filter-chips').forEach((bar) => {
    bar.addEventListener('click', (e) => {
      if (e.target.classList.contains('chip')) {
        bar.querySelectorAll('.chip').forEach((c) => c.classList.remove('active'));
        e.target.classList.add('active');
      }
    });
  });

  document.querySelectorAll('[data-hover-swap]').forEach((card) => {
    const img = card.querySelector('img');
    const primary = img?.src;
    const alt = card.dataset.hoverSwap;
    if (!img || !alt) return;
    card.addEventListener('mouseenter', () => { img.src = alt; });
    card.addEventListener('mouseleave', () => { if (primary) img.src = primary; });
  });

})();
